"use strict";
// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var detect_browser_1 = require("detect-browser");
var DefaultBrowserBehavior = /** @class */ (function () {
    function DefaultBrowserBehavior() {
        this.browser = detect_browser_1.detect();
        this.browserSupport = {
            chrome: 78,
            'edge-chromium': 79,
            electron: 7,
            firefox: 60,
            ios: 12,
            safari: 12,
            opera: 66,
        };
        this.browserName = {
            chrome: 'Google Chrome',
            'edge-chromium': 'Microsoft Edge',
            electron: 'Electron',
            firefox: 'Mozilla Firefox',
            ios: 'Safari iOS',
            safari: 'Safari',
            opera: 'Opera',
        };
        this.chromeLike = ['chrome', 'edge-chromium', 'chromium-webview', 'opera'];
    }
    DefaultBrowserBehavior.prototype.version = function () {
        return this.browser.version;
    };
    DefaultBrowserBehavior.prototype.majorVersion = function () {
        return parseInt(this.version().split('.')[0]);
    };
    DefaultBrowserBehavior.prototype.name = function () {
        return this.browser.name;
    };
    DefaultBrowserBehavior.prototype.hasChromiumWebRTC = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.chromeLike), _c = _b.next(); !_c.done; _c = _b.next()) {
                var browser = _c.value;
                if (browser === this.browser.name) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    DefaultBrowserBehavior.prototype.hasFirefoxWebRTC = function () {
        return this.isFirefox();
    };
    DefaultBrowserBehavior.prototype.screenShareSendsOnlyKeyframes = function () {
        return this.isFirefox();
    };
    DefaultBrowserBehavior.prototype.requiresUnifiedPlan = function () {
        return this.isSafari() || this.isFirefox();
    };
    DefaultBrowserBehavior.prototype.requiresCheckForSdpConnectionAttributes = function () {
        return !this.isIOSSafari();
    };
    DefaultBrowserBehavior.prototype.requiresIceCandidateGatheringTimeoutWorkaround = function () {
        return this.hasChromiumWebRTC();
    };
    DefaultBrowserBehavior.prototype.requiresUnifiedPlanMunging = function () {
        return this.isSafari();
    };
    DefaultBrowserBehavior.prototype.requiresBundlePolicy = function () {
        if (this.isSafari() || this.isFirefox()) {
            return 'max-bundle';
        }
        else {
            return 'balanced';
        }
    };
    DefaultBrowserBehavior.prototype.requiresPromiseBasedWebRTCGetStats = function () {
        return !this.hasChromiumWebRTC();
    };
    DefaultBrowserBehavior.prototype.screenShareUnsupported = function () {
        if (this.isSafari()) {
            return true;
        }
        return false;
    };
    DefaultBrowserBehavior.prototype.isSupported = function () {
        return this.majorVersion() >= this.browserSupport[this.browser.name];
    };
    DefaultBrowserBehavior.prototype.supportString = function () {
        var s = [];
        for (var k in this.browserSupport) {
            s.push(this.browserName[k] + " " + this.browserSupport[k] + "+");
        }
        return s.join(', ');
    };
    // These helpers should be kept private to encourage
    // feature detection instead of browser detection.
    DefaultBrowserBehavior.prototype.isIOSSafari = function () {
        return this.browser.name === 'ios';
    };
    DefaultBrowserBehavior.prototype.isSafari = function () {
        return this.browser.name === 'safari' || this.browser.name === 'ios';
    };
    DefaultBrowserBehavior.prototype.isFirefox = function () {
        return this.browser.name === 'firefox';
    };
    return DefaultBrowserBehavior;
}());
exports.default = DefaultBrowserBehavior;
//# sourceMappingURL=DefaultBrowserBehavior.js.map